import React from "react";
import "./HomeCard.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { userDetail } from "../../../../Redux/userSlice";

import { setInnerLoaderFalse, setInnerLoaderTrue } from "../../../../Redux/loaderSlice";
// import { t } from "i18next";
// import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
// import { navbarData } from "../../../../Data/HomePageData";
import { rootUrl } from "../../../../App";

const HomeCard = ({ cardData }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const user = useSelector(userDetail);

    // const [selectedLeftBarData, setSelectedLeftBarData] = useState(homeLeftData[0]);
    // console.log(thumbnail);

    return (
        <div className="home-card-area ms-2 ps-2">

            {
                // (!thumbnail || (thumbnail === null)) &&
                // <SkeletonTheme baseColor="var(--homeCardColo)" highlightColor="var(--lightGray)">
                //     <Skeleton count={7} width={"100%"} height={100} duration={1} />
                // </SkeletonTheme>
                // :
                cardData?.map((item, index) =>
                    (item?.menu_card) &&
                    <div key={item?.id || index} className={"home-card rounded custom-shadow position-relative"}
                        onClick={() => {
                            dispatch(setInnerLoaderTrue());

                            // if (!user?.is_login) {
                            //     navigate("/login");
                            // } else {
                            // }
                            navigate(item?.page?.name);

                            const timer = setTimeout(() => {
                                dispatch(setInnerLoaderFalse());
                            }, 1000);
                            return () => clearTimeout(timer);
                        }}
                        style={{ cursor: "pointer", }}>
                        {/* <h5>{t(item?.name)}</h5> */}
                        {/* <h5>{"test" + index}</h5> */}
                        <span className="ribbon">{item?.title}</span>
                        <span className="fw-bold text-uppercase audiowide-font" style={{ position: "absolute", bottom: "5px", left: "10px", fontSize: "1.1rem", opacity: "0.1", zIndex: 4, }}>{item?.title}</span>
                        {/* <span className="ribbon-band">x</span> */}
                        <span className="inverted-border-radius fw-bold text-uppercase text-start">
                            <span style={{ position: "absolute", left: "10px", top: "6px", }}>
                                {item?.title}
                            </span>
                        </span>

                        {
                            (item?.thumbnail) &&
                            <img src={rootUrl + item?.thumbnail} alt={item?.alt_text} width={"100%"} />
                        }
                    </div>
                )
            }
        </div>
    );
};

export default HomeCard;